import { discoveryApiRef, identityApiRef } from "@backstage/core-plugin-api";
import { ApiBlueprint, createApiFactory } from "@backstage/frontend-plugin-api";
import { SecurityInsightsAggregatedClient } from "@internal/backstage-plugin-security-insights-common";
import { securityInsightsApiRef } from "@internal/backstage-plugin-security-insights-react";

export const securityInsightsApi = ApiBlueprint.make({
    name: "security-insights",
    params: defineParams =>
        defineParams(
            createApiFactory({
                api: securityInsightsApiRef,
                deps: {
                    discoveryApi: discoveryApiRef,
                    identityApi: identityApiRef,
                },
                factory: ({ discoveryApi, identityApi }) =>
                    new SecurityInsightsAggregatedClient({
                        discoveryApi,
                        identityApi,
                    }),
            })
        ),
});
